export const SET_COMPANY_INTEGRATION =  "SET_COMPANY_INTEGRATION"
